import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ITutorChange, ITutorInitState } from "../types";



const init: ITutorInitState = {
    tutor: {
        full_name: '',
        tag_ids: [],
        cost_per_hour: '',
        tg: '',
        work_tg_name: '',
        work_tg_ids: [],
        email: '',
        phone: '',  
    },
    isLoading: true,
    error: ''
}

export const TutorSlice = createSlice({
    name: 'tutor',
    initialState: init,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>){
            state.isLoading = action.payload;
        },
        setInit(state, action: PayloadAction<void>){
            state.tutor = init.tutor;
        },
        setTutor(state, action: PayloadAction<ITutorChange>){
            state.tutor = action.payload;
        },
        setFullName(state, action: PayloadAction<string>){
            state.tutor.full_name = action.payload;
        },
        setCostPerHour(state, action: PayloadAction<string>){
            state.tutor.cost_per_hour = action.payload;
        },
        setPhone(state, action: PayloadAction<string>){
            state.tutor.phone = action.payload;
        },
        setTg(state, action: PayloadAction<string>){
            state.tutor.tg = action.payload;
        },
        setTagIds(state, action: PayloadAction<number[]>){
            state.tutor.tag_ids = action.payload;
        },
        setEmail(state, action: PayloadAction<string>){
            state.tutor.email = action.payload;
        },
        setWorkTgIds(state, action: PayloadAction<number[]>){
            state.tutor.work_tg_ids = action.payload;
        },
        setWorkTgName(state, action: PayloadAction<string>){
            state.tutor.work_tg_name = action.payload;
        },

    }
})

export default TutorSlice.reducer
